import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Box,
  Button,
  CardContent,
  Grid,
  Stack,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  MenuItem,
  Alert,
  Container,
  OutlinedInput,
  FormControl,
  InputLabel
} from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';

import Iconify from '../../../components/Iconify';
import { api } from 'src/Api';

export default function AddAdminModal({ handleClose, user, refreshAdmin, fullWidth }) {
  const [alert, setAlert] = useState({ visible: false, message: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [firstname, setfirstame] = useState('');
  const [lastname, setlastname] = useState('');
  const [email, setemail] = useState('');
  const [phone, setPhone] = useState(''); // New phone state
  const [password, setpassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [reasondrop, setReasondrop] = useState(null);
  const [loading, setloading] = useState(false);
  const [file, setfile] = useState({ image: user.avatar, file: '' });
  const [error, setError] = useState(false);

  const token = localStorage.getItem('token');

  const [objAfter, setobjAfter] = useState({
    name: user?.name,
    file: false
  });
  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleChangeRoles = (event) => {
    const selectedRole = event.target.value;
    setReasondrop(selectedRole);
  };
  console.log('role', reasondrop?.id);

  function handleAddUser() {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('role_id', reasondrop?.id);
    formdata.append('first_name', firstname);
    formdata.append('last_name', lastname);
    formdata.append('email', email);
    formdata.append('contact_no', phone);
    formdata.append('password', password);
    formdata.append('password_confirmation', confirmpassword);
    if (file && file.file) {
      formdata.append('avatar', file.file);
    }
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    setloading(true);
    for (var pair of formdata.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    }
    fetch(api.create_user, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.text();
        } else {
          return response.json().then((result) => {
            console.log('=======', result?.error);
            setAlert({ visible: true, message: result.error });
          });
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);

        refreshAdmin();
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  }
  const exceptThisSymbols = ['e', 'E', '+', '-', '.'];
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e) => {
    const value = e.target.value;

    if (value.length <= 50) {
      setemail(value);

      // Validate email format
      setError(value && !emailRegex.test(value));
    }
  };

  return (
    <Box p={1} mt={2} style={{ width: '100%' }}>
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {t('Add User')}
      </Typography>
      <CardContent>
        <Stack
          mb={2}
          direction={{ xs: 'column' }}
          style={{ display: 'flex', flexDirection: 'row' }}
          className="image_center"
        >
          <Box
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {file && (
              <Avatar
                alt="Avatar"
                src={objAfter?.file ? file.image : null}
                sx={{ width: 80, height: 80 }}
                className="image_center"
              />
            )}
            <Button
              style={{
                width: !file ? 80 : null,
                height: !file ? 80 : 30,
                borderRadius: !file ? 40 : 20,
                marginTop: 10,
                marginBottom: 10,
                fontSize: 12
              }}
              variant={file ? 'outlined' : 'outlined'}
              component="label"
            >
              {t('EditProfile.buttons.0')}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  setobjAfter({
                    file: true
                  });
                  setfile({
                    image: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  });
                }}
              />
            </Button>
          </Box>
        </Stack>
        <Grid container spacing={2} className="top_column">
          <>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'First Name'}
                type="text"
                value={firstname}
                onChange={(val) => {
                  if (val.target.value.length <= 20) {
                    setfirstame(val.target.value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                id="outlined-error-helper-text"
                fullWidth
                label={'Last Name'}
                type="text"
                value={lastname}
                onChange={(val) => {
                  if (val.target.value.length <= 20) {
                    setlastname(val.target.value);
                  }
                }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <TextField
                fullWidth
                label={'Email'}
                type="text"
                value={email}
                error={error}
                helperText={error ? 'Invalid email' : ''}
                onChange={handleChange}
                // onChange={(val) => {
                //   if (val.target.value.length <= 50) {
                //     setemail(val.target.value);
                //   }
                // }}
                variant="outlined"
                display="inline"
              />
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password"> Password</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowPassword}
                        edge="end"
                      >
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
            </Grid>

            <Grid item lg={6} sm={12} md={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={showPassword ? 'text' : 'password'}
                  value={confirmpassword}
                  onChange={(e) => setConfirmpassword(e.target.value)}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowPassword}
                        edge="end"
                      >
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Confirm Password"
                />
              </FormControl>
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                fullWidth
                label={'Contact'}
                type="number"
                value={phone}
                onChange={(val) => {
                  if (val.target.value.length <= 20) {
                    setPhone(val.target.value);
                  }
                }}
                variant="outlined"
                display="inline"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
              />
            </Grid>
            <Grid item lg={6} sm={12} md={12}>
              <TextField
                fullWidth={fullWidth}
                style={{ width: !fullWidth && '20%', marginLeft: !fullWidth && 15 }}
                select
                value={reasondrop}
                label={'Role'}
                onChange={handleChangeRoles}
              >
                {user.slice(1).map((option) => (
                  <MenuItem key={option.id} value={option}>
                    {option.role_name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </>
        </Grid>
      </CardContent>
      {alert && !alert?.message?.includes('success') && alert?.message != '' && (
        <Alert style={{ marginTop: 10 }} severity="error">
          {alert?.message}
        </Alert>
      )}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
        <LoadingButton
          disabled={!firstname || !lastname || !email || !phone || !reasondrop || error}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={() => {
            handleAddUser();
          }}
          color="primary"
          variant="contained"
        >
          {t('EditProfile.buttons.1')}
        </LoadingButton>
        <LoadingButton
          sx={{
            marginRight: 1
          }}
          onClick={handleClose}
          variant="outlined"
        >
          {t('EditProfile.buttons.2')}
        </LoadingButton>
      </Box>
    </Box>
  );
}
